"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkField = void 0;
var react_1 = require("@chakra-ui/react");
var react_2 = __importDefault(require("react"));
var LinkField = function (_a) {
    var linkData = _a.linkData;
    return (react_2.default.createElement(react_1.Link, { width: "100%", target: linkData.data.target ? linkData.data.target : undefined, rel: linkData.data.target ? "noopener noreferrer" : undefined, href: linkData.data.link ? linkData.data.link : undefined, css: linkData.style, className: "" + (linkData.class ? linkData.class : "") }, linkData.data.body ? linkData.data.body : linkData.data.link));
};
exports.LinkField = LinkField;
